import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  if (reviews.length === 0) return null;
  return <section aria-labelledby="reviews-heading" className="topo-light w-full bg-paper text-pine" data-id="element-240" data-mp="2hefbyqdgjd2p">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-241" data-mp="2raie3w8b7bpn">
        <div className="text-center" data-id="element-242" data-mp="2rc3alre6p4q5">
          <p className="eyebrow text-ember-deep" data-id="element-243" data-mp="2wa4ozz0o0fva">From the circle</p>
          <h2 id="reviews-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-244" data-mp="2w7sa5uq7elmg">
            What facilitators are seeing with their groups
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-245" data-mp="3a1t0c033b0b7">
            Facilitators using Vivencia Ready with their weekly groups.
          </p>
        </div>

        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-246" data-mp="3jzgx0vk9ahw0">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-247" data-mp="2rd6ym6tq62p8">
              <figure className="flex w-full flex-col border-t-2 border-ember pt-5" data-id="element-248" data-mp="2rdyrh9vxtmbt">
                <blockquote className="text-[17px] leading-relaxed text-pine" data-id="element-249" data-mp="2mbzrm9zep7jm">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-250" data-mp="2dd5wyp5myr8p">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-display text-sm text-paper" data-id="element-251" data-mp="2df8x420i60r5">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-pine-soft" data-id="element-252" data-mp="30b95v441xrky">
                    <span className="block text-[14px] font-bold text-pine" data-id="element-253" data-mp="2wayzhqcckz5k">
                      {review.name}
                    </span>
                    {review.role}
                    {review.city && review.country && <span className="mt-0.5 flex items-center gap-1 text-pine-muted" data-id="element-254" data-mp="3o0tqdrfuswwc">
                        <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-255" data-mp="1m65z23kkw323" />
                        {review.city}, {review.country}
                      </span>}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}